export default __webpack_public_path__ + "static/media/phonelogo.393df3f4.svg";